export default "__VITE_ASSET__ByqKlZ2i__"